import { render, staticRenderFns } from "./KitchenSetup.vue?vue&type=template&id=506824ec&"
import script from "./KitchenSetup.vue?vue&type=script&lang=ts&"
export * from "./KitchenSetup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports